export function convertFormDataToPayload(
  formData: Record<string, string | boolean | number>
) {
  const payload = []

  for (const key in formData) {
    let value = formData[key] ?? null

    if (key === 'gender' && typeof value === 'string') {
      value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    }

    const fieldData = {
      fieldCode: key,
      fieldValue: value,
    }

    payload.push(fieldData)
  }

  return payload.length ? { data: payload } : null
}
